<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <template v-if="currentStep===0">
      <kudos-search-list
        v-model="form.kudo"
        :kudos="kudos"
        :received="received"
        :selectable="true"
        @select="$emit('select-kudo', $event)"
      />
    </template>
    <template v-else-if="currentStep===1">
      <b-form-group label-for="input-comment" class="mt-4">
        <template #label>
          <span class="font-weight-bold color-deeppink">Explain in a few words why you are giving this kudo</span>
        </template>
        <b-form-textarea
          id="input-comment"
          v-model="form.comment"
          :state="isValidField('comment')"
          rows="8"
          placeholder="Comment"
        />
        <b-form-invalid-feedback :state="isValidField('comment')">
          <div v-for="error in errors.comment || []" :key="error">
            {{ error }}
          </div>
        </b-form-invalid-feedback>
      </b-form-group>
    </template>
    <template v-else-if="currentStep===2">
      <div class="d-flex align-items-center">
        <h5 class="mr-5">Sender identity</h5>
        <toggle-button
          v-model="form.isPublic"
          :labels="{ checked: 'Public', unchecked: 'Anonymous' }"
          :width="150"
          :height="30"
          :font-size="15"
        />
      </div>
      <div class="bg-color-lightgray2 p-3 mt-3">
        <h5>
          <template v-if="form.isPublic">Public mode</template>
          <template v-else>Anonymous mode</template>
        </h5>
        <p>
          <template v-if="form.isPublic">
            Your name and picture will be displayed when a user looks at the kudo's detail.
          </template>
          <template v-else>
            Your name and picture will be hidden when a user looks at the kudo's detail.
          </template>
        </p>
        <div>
          <div class="d-inline-block">
            <div>
              <avatar :src="form.isPublic ? giver.photo : undefined" size="3rem" />
            </div>
            <div class="font-weight-bold mt-2">
              {{giverName}}
            </div>
            <div class="mt-2" v-html="commentHtml" />
          </div>
        </div>
      </div>
    </template>
    <b-form-row class="mt-5">
      <b-col>
        <b-button v-if="currentStep!==0" :disabled="submitting" variant="outline-primary" class="pl-5 pr-5" @click.prevent="onBack">
          Back
        </b-button>
      </b-col>
      <b-col cols="auto">
        <b-button v-if="currentStep===2" type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Finish</b-button>
        <b-button v-else :disabled="submitting" pill variant="primary" class="pl-5 pr-5" @click.prevent="onNext">Continue</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import MixinForm from './MixinForm'
import { KudosSearchList } from '@/components/KudosList'
import Avatar from '@/components/common/Avatar'
import { GiveKudo } from '@/helpers/messageContent'
import { linebreaks, userName } from '@/helpers/helpers'

export default {
  name: 'GiveKudoForm',

  mixins: [MixinForm],

  props: {
    kudos: {
      type: Array
    },

    received: {
      type: Array
    },

    receiver: {
      type: Object,
      required: true
    },

    receiverType: {
      type: String,
      required: true
    },

    giver: {
      type: Object,
      required: true
    }
  },

  watch: {
    receiver(value) {
      this.form.receiverId = value.id
    },

    receiverType(value) {
      this.form.receiverType = value
    }
  },

  data() {
    return {
      form: {
        receiverId: this.receiver.id,
        receiverType: this.receiverType,
        kudo: undefined,
        comment: GiveKudo,
        isPublic: true
      },
      currentStep: 0
    }
  },

  computed: {
    commentHtml() {
      return linebreaks(this.form.comment)
    },

    giverName() {
      return this.form.isPublic ? userName(this.giver) : 'Anonymous'
    }
  },

  methods: {
    onBack() {
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },

    onNext() {
      if (this.currentStep < 2) {
        this.errors = this.validateStep(this.currentStep, this.form)
        if (this.isValid) {
          this.currentStep++
        }
      }
    },

    validateStep(step, data) {
      const errors = {}
      switch (step) {
        case 0:
          if (typeof data.kudo !== 'number') errors.kudo = ["Kudo can't be blank"]
          break
        case 1:
          if (validator.isEmpty(data.comment || '')) errors.comment = ["Comment can't be blank"]
          break
      }
      return errors
    },

    validate(data) {
      return {
        ...this.validateStep(0, data),
        ...this.validateStep(1, data)
      }
    }
  },

  components: {
    KudosSearchList,
    Avatar
  }
}
</script>
